import React from 'react';
import PropTypes from 'prop-types';
import { Bert } from 'meteor/themeteorchef:bert';
import { Row, Col, Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import * as annotationOps from '../../../api/Annotations/annotation-operations';
import handleErrorInClient from '../../../modules/handle-error-in-client';
import methodPromise from '../../../modules/method-promise-wrapper';

import ColBreak from '../../atoms/ColBreak';
import AnnotationTemplatePreview from '../AnnotationTemplatePreview';

import Styles from './styles';

const handleHardRemove = async ({ annotation, changeVideoContainerStateProperty }) => {
  // eslint-disable-next-line no-alert
  if (window.confirm('Are you sure? This is permanent!')) {
    try {
      await methodPromise('annotations.hardDelete', annotationOps.getId(annotation));
      changeVideoContainerStateProperty('selectedAnnotation', {});
      Bert.alert(`Annotation deleted!`, 'danger');
    } catch (error) {
      handleErrorInClient(error);
    }
  }
};

const ViewAnnotation = ({
  annotation,
  changeVideoContainerStateProperty,
  isPublic,
  isPreviewMapEditor,
  ...rest
}) => {
  return (
    <Styles.ViewAnnotation>
      <Row>
        <Col xs={12} className="d-flex justify-content-end">
          <Button
            className="close"
            aria-label="Close"
            onClick={() => changeVideoContainerStateProperty('selectedAnnotation', {})}
          >
            <span aria-hidden="true">&times;</span>
          </Button>
        </Col>
        <Col xs={12}>
          <AnnotationTemplatePreview
            annotationTemplate={annotationOps.getTemplate(annotation)}
            previewMode="preview"
            isPreviewMapEditor={isPreviewMapEditor}
            annotation={annotation}
            {...rest}
          />
        </Col>
        {!isPublic && (
          <>
            <ColBreak />
            <Col xs={12} className="d-flex justify-content-end">
              <Button
                variant="light"
                onClick={() => changeVideoContainerStateProperty('readOnly', false)}
              >
                Edit
              </Button>
              <Button
                variant="danger"
                onClick={() => handleHardRemove({ annotation, changeVideoContainerStateProperty })}
              >
                <FontAwesomeIcon icon="trash-alt" />
              </Button>
            </Col>
          </>
        )}
      </Row>
    </Styles.ViewAnnotation>
  );
};

ViewAnnotation.defaultProps = {
  isPreviewMapEditor: false
};

ViewAnnotation.propTypes = {
  annotation: PropTypes.object.isRequired,
  changeVideoContainerStateProperty: PropTypes.func.isRequired,
  isPublic: PropTypes.bool.isRequired,
  isPreviewMapEditor: PropTypes.bool
};

export default ViewAnnotation;
